'use client'

import Link from 'next/link'
import { Button, ClippedImage, cn, RightTopArrow } from '@desoutter/uikit'
import { Tag } from '@desoutter/uikit'
import { useParams } from 'next/navigation'
import { LocalizedLink } from '@/components/LocalizedLink'

type ProductCardProps = {
	partnumber: string
	model: string
	imageUrl?: string
	slogan?: string
	specs?: { [key: string]: string }[]
	className?: string
	trackingClassname?: string
}

export const ProductCard = ({
	partnumber,
	model,
	imageUrl,
	slogan,
	specs,
	className,
	trackingClassname,
}: ProductCardProps) => {
	const { lang } = useParams()

	return (
		<LocalizedLink
			locale={lang}
			href={`/products/${partnumber}`}
			prefetch={false}
			rel="nofollow"
			className={trackingClassname}
		>
			<div
				className={cn(
					'relative bg-gray-50 rounded-3xl md:h-[400px] w-full md:w-[280px] p-4 flex flex-col gap-2',
					className,
				)}
			>
				<div className="absolute top-6 right-6 z-20">
					<Button
						title="go to article"
						color="secondary"
						icon={RightTopArrow}
						size="md"
					/>
				</div>

				<ClippedImage
					src={imageUrl}
					alt="product"
					width={233}
					height={233}
					sourceWidth={250}
					sourceHeight={250}
					className="rounded-xl object-cover w-full max-w-full h-[233px] max-h-[233px]"
				/>
				<div className="flex flex-col mt-1 gap-1">
					<Tag variant="tertiary" label={partnumber} />

					<h3 className="h5 font-bold m-0 mt-2 text-md line-clamp-2">
						{model}
					</h3>
					<p className="text-sm line-clamp-2">{slogan}</p>
					{specs?.map(
						(spec, index) =>
							index < 2 && (
								<div
									key={index}
									className="flex justify-between text-sm text-gray-500 line-clamp-1"
								>
									<div>{Object.keys(spec)[0]}</div>
									<div>{Object.values(spec)[0]}</div>
								</div>
							),
					)}
				</div>
			</div>
		</LocalizedLink>
	)
}
